import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSplitPath = ({ title, titleId, ...props }) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("g", {
			clipPath: "url(#clip0_14861_200725)",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M9.75 4.75H5.80566L12 11.0703L18.1943 4.75H14.25V3.25L20.75 3.25V9.75H19.25V5.81641L12.75 12.4492L12.75 20.75H11.25V12.4492L4.75 5.81641V9.75H3.25L3.25 3.25L9.75 3.25V4.75Z",
				fill: "currentcolor"
			})
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_14861_200725",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 18,
				height: 18,
				fill: "white",
				transform: "translate(3 3)"
			})
		}) })
	]
});
export default SvgSplitPath;
